/**
 * Media CDN Configuration
 *
 * In production, media is served from Cloudflare R2 for better performance and cost.
 * In development, media is served locally from /public.
 *
 * Set EXPO_PUBLIC_MEDIA_CDN_URL in your environment:
 * - Production: https://pub-xxxxx.r2.dev (or your custom domain like https://media.reactiive.io)
 * - Development: leave empty to use local files
 */

const MEDIA_CDN_URL = process.env.EXPO_PUBLIC_MEDIA_CDN_URL || '';

export const getMediaUrl = (path: string): string => {
  // Remove leading slash if present for CDN URLs
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  if (MEDIA_CDN_URL) {
    return `${MEDIA_CDN_URL}/${cleanPath}`;
  }

  // Local development - use relative path
  return `/${cleanPath}`;
};

// Convenience functions
export const getDemoVideoUrl = (name: string): string => {
  return getMediaUrl(`demos/videos/${name}.mp4`);
};

export const getDemoThumbnailUrl = (name: string): string => {
  return getMediaUrl(`demos/thumbnails/${name}.webp`);
};

export const getMainDemoVideoUrl = (): string => {
  return getMediaUrl('demos/main/demos-main.mp4');
};
